import { MediaTypes } from 'components/altsumm-modal/components/media-input/MediaInput.utils';

export const URL_REGEX =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|org|net|edu|gov|mil|int|co|io|ai|app|dev|tech|info|biz|name|pro|museum|travel|mobi|tel|asia|jobs|cat|post|xxx|aero|coop|ly|gl|me|tv|cc|ws|be|it|de|fr|es|uk|us|ca|au|jp|cn|in|br|ru|nl|se|no|fi|dk|pl|tr|za|nz|sg|hk|th|my|id|ph|vn|tw|kr|ar|cl|pe|ve|uy|py|bo|ec|mx|gt|hn|sv|ni|cr|pa|do|cu|jm|tt|bb|gy|sr|gf|fk|bz|ag|lc|vc|gd|dm|kn|ms|vg|ky|bm|tc)(\/[^\s]*)?$/;

export const LC_CARD_URL_REGEX = /https?:\/\/(?:www\.)?(?:[^.]+\.)?(wsj)\.com\/livecoverage\/([^/]+)\/card\/.*-([^/]+)/;
export function resizeIMImage(
  imageUrl: string | undefined,
  { width, height, size }: { width: number; height?: number; size?: number },
  mediaType: MediaTypes = ''
) {
  if (mediaType === 'video') {
    return imageUrl;
  }
  if (imageUrl) {
    let url: URL;
    try {
      url = new URL(imageUrl);
    } catch (error) {
      console.warn(`Found invalid URL ${imageUrl}, when attempting to resize image`);
      return undefined;
    }

    url.searchParams.set('width', `${width}`);
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    url.searchParams.set('pixel_ratio', `${window.devicePixelRatio ?? 2}`);
    if (url.searchParams.get('height')) {
      url.searchParams.delete('height');
    }
    if (height) {
      url.searchParams.set('height', `${height}`);
    }
    if (size) {
      url.searchParams.set('size', `${size}`);
    }

    return url.toString();
  }

  return imageUrl;
}

export function getIMImageAspectRatio(imageUrl: string | undefined) {
  if (imageUrl) {
    let url: URL;
    try {
      url = new URL(imageUrl);
    } catch (error) {
      console.warn(`Found invalid URL ${imageUrl}, when attempting to get image aspect ratio`);
      return null;
    }

    const aspectRatio = url.searchParams.get('size');
    if (aspectRatio) {
      return parseFloat(aspectRatio);
    }
  }

  return null;
}

export function extractSizeFromUrl(url?: string): number {
  if (!url) return 0;
  const regex = /(?<=size=)[0-9.]+/;
  const sizeMatch = url.match(regex);
  if (sizeMatch) {
    return Number(sizeMatch[0]);
  }
  return 1;
}

export const isValidURL = (url: string): boolean => {
  try {
    const { protocol } = new URL(url);
    return protocol === 'https:' || protocol === 'http:';
  } catch (e) {
    return false;
  }
};

export const formatBulletLink = (bullet: string, title?: string) => `<a href="${bullet}">${title ?? bullet}</a>`;
